import { DemographicHypeAuditor, HypeAuditorGenderType } from '../../../../models/demographic/demographic-hype-auditor';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { UserService } from '../../../services/user.service';
import { CommonConstant, GenderEnum } from '../../../app.constants';
import { NumberUtils } from '../../../utils/number.utils';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { InfluencerDemographicsComponent } from '../influencer-demographics/influencer-demographics.component';
var DemographicHypeAuditorComponent = /** @class */ (function () {
    function DemographicHypeAuditorComponent(translate, referenceDataService, pdfService, userService) {
        this.translate = translate;
        this.referenceDataService = referenceDataService;
        this.pdfService = pdfService;
        this.userService = userService;
    }
    DemographicHypeAuditorComponent.prototype.ngOnInit = function () {
        this.buildLanguagesBarChartData();
        this.buildCitiesBarChartData();
        this.genderPerAgeChart = this.transformDemographyAgeChartData(this.demographicData.demographyByAge);
        this.genderPerAgeChartMaxPercent = InfluencerDemographicsComponent.getMaxPercentOfGenderPerAge(this.genderPerAgeChart);
    };
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "genderChartData", {
        get: function () {
            var _this = this;
            var sortedGenders = this.demographicData.genders.filter(function (x) { return x.gender === HypeAuditorGenderType.MALE; }).concat(this.demographicData.genders.filter(function (x) { return x.gender !== HypeAuditorGenderType.MALE; }));
            return sortedGenders.map(function (g) { return ({
                name: _this.getGenderName(g.gender),
                y: g.value / 100,
                color: g.gender === HypeAuditorGenderType.MALE ? _this.userService.chartColors[GenderEnum.MALE] : _this.userService.chartColors[GenderEnum.FEMALE]
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasGenderChartData", {
        get: function () {
            return this.demographicData.genders && this.demographicData.genders.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "countriesChartData", {
        get: function () {
            return this.demographicData.countries.map(function (c) { return ({
                name: c.name,
                y: c.value / 100
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasCountriesChartData", {
        get: function () {
            return this.demographicData.countries && this.demographicData.countries.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "isGenderPerAgeAvailabel", {
        get: function () {
            return this.genderPerAgeChart && this.genderPerAgeChart.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasAudienceInterestData", {
        get: function () {
            return this.demographicData.audienceInterest
                && this.demographicData.audienceInterest.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "firstHalfAudienceInterestChartData", {
        get: function () {
            if (!this.demographicData.audienceInterest) {
                return [];
            }
            var totalAudienceInterest = this.demographicData.audienceInterest.length;
            var firstHalfData = this.demographicData.audienceInterest.slice(0, totalAudienceInterest / 2);
            var result = firstHalfData.map(function (ai) { return ({
                title: ai[0].indexOf('and') >= 0 ? ai[0].replace('and', '&') : ai[0].replace('&amp;', '&'),
                value: Math.round(ai[1] * 100),
                formattedValue: Math.round(ai[1] * 100) + '%'
            }); });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "secondHalfAudienceInterestChartData", {
        get: function () {
            if (!this.demographicData.audienceInterest) {
                return [];
            }
            var totalAudienceInterest = this.demographicData.audienceInterest.length;
            var secondHalfData = this.demographicData.audienceInterest.slice(totalAudienceInterest / 2, totalAudienceInterest);
            return secondHalfData.map(function (ai) { return ({
                title: ai[0].indexOf('and') >= 0 ? ai[0].replace('and', '&') : ai[0].replace('&amp;', '&'),
                value: Math.round(ai[1] * 100),
                formattedValue: Math.round(ai[1] * 100) + '%'
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "startingIndexOfSecondHalf", {
        get: function () {
            if (!this.demographicData.audienceInterest) {
                return 0;
            }
            var totalAudienceInterest = this.demographicData.audienceInterest.length;
            return Math.round((totalAudienceInterest / 2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "audienceTypeChartData", {
        get: function () {
            if (!this.demographicData.audienceType ||
                (!this.demographicData.audienceType.real && !this.demographicData.audienceType.infs &&
                    !this.demographicData.audienceType.mass && !this.demographicData.audienceType.susp)) {
                return [];
            }
            return this.buildAudienceAndAuthenticChartData(this.demographicData.audienceType.real, this.demographicData.audienceType.infs, this.demographicData.audienceType.mass, this.demographicData.audienceType.susp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasAudienceTypeData", {
        get: function () {
            return this.audienceTypeChartData.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    DemographicHypeAuditorComponent.prototype.buildLanguagesBarChartData = function () {
        var _this = this;
        if (!Array.isArray(this.demographicData.languages)) {
            return;
        }
        this.languagesBarChartData = this.demographicData.languages.map(function (lang) { return ({
            title: lang.name ? lang.name : _this.getLanguage(lang.code),
            value: lang.value,
            formattedValue: NumberUtils.normalizeNumberToString(lang.value, 1) + '%'
        }); }).slice(0, 5);
    };
    DemographicHypeAuditorComponent.prototype.buildCitiesBarChartData = function () {
        if (!Array.isArray(this.demographicData.cities)) {
            return;
        }
        this.citiesBarChartData = this.demographicData.cities.map(function (lang) { return ({
            title: lang.name,
            value: lang.value,
            formattedValue: NumberUtils.normalizeNumberToString(lang.value, 1) + '%'
        }); });
    };
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasCitiesChartData", {
        get: function () {
            return this.demographicData.cities && this.demographicData.cities.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "languageChartColor", {
        get: function () {
            return this.userService.chartColors[7];
        },
        enumerable: true,
        configurable: true
    });
    DemographicHypeAuditorComponent.prototype.getLanguage = function (lang) {
        var language = this.referenceDataService.languages.find(function (la) { return la.code === lang; });
        return language ? language.name : '';
    };
    DemographicHypeAuditorComponent.prototype.buildAudienceAndAuthenticChartData = function (real, infs, mass, susp) {
        var audienceTypeChartData = [];
        audienceTypeChartData.push({
            name: this.translate.instant('hype_auditor_demographic.audience_type.real'),
            y: real / 100
        });
        audienceTypeChartData.push({
            name: this.translate.instant('hype_auditor_demographic.audience_type.infs'),
            y: infs / 100
        });
        audienceTypeChartData.push({
            name: this.translate.instant('hype_auditor_demographic.audience_type.mass'),
            y: mass / 100
        });
        audienceTypeChartData.push({
            name: this.translate.instant('hype_auditor_demographic.audience_type.susp'),
            y: susp / 100
        });
        return audienceTypeChartData;
    };
    DemographicHypeAuditorComponent.prototype.getGenderName = function (gender) {
        if (gender === HypeAuditorGenderType.MALE) {
            return this.translate.instant('INFLUENCER.CHART.GENDER_PER_AGE.MALE');
        }
        else {
            return this.translate.instant('INFLUENCER.CHART.GENDER_PER_AGE.FEMALE');
        }
    };
    DemographicHypeAuditorComponent.prototype.transformDemographyAgeChartData = function (rawData) {
        var _this = this;
        if (!rawData || rawData.length === 0) {
            return [];
        }
        var maleGroup = rawData[0].by_age_group;
        var femaleGroup = rawData[1].by_age_group;
        var demographyAges = [];
        var maleAgeGroups = maleGroup.map(function (g) { return g.group; });
        var femaleAgeGroups = femaleGroup.map(function (g) { return g.group; });
        var ageGroups = new Set(maleAgeGroups.concat(femaleAgeGroups));
        // sorted set age range
        var sortedAgeGroups = Array.from(ageGroups).sort();
        sortedAgeGroups.forEach(function (g) {
            var mValue = _this.findAgeByGroup(g, maleGroup);
            var fValue = _this.findAgeByGroup(g, femaleGroup);
            if (mValue > 0 || fValue > 0) {
                demographyAges.push({
                    range: !_this.isDeepSocialData ? _this.formatAgeGroupName(g) : _this.formatDeepSocailAgeGroupName(g),
                    f: fValue,
                    m: mValue,
                });
            }
        });
        demographyAges = demographyAges.concat(CommonConstant.GENDER_PER_AGE_DEFAULT_VALUE.filter(function (defaultItem) { return demographyAges.every(function (demographyAgesItem) { return demographyAgesItem.range !== defaultItem.range; }); }))
            .sort(function (a, b) { return a.range.localeCompare(b.range); });
        return demographyAges;
    };
    DemographicHypeAuditorComponent.prototype.formatDeepSocailAgeGroupName = function (group) {
        if (group === CommonConstant.AGE_RANGE_45_64) {
            return group = CommonConstant.REPLACED_45_64_AGE_RANGE;
        }
        return group;
    };
    DemographicHypeAuditorComponent.prototype.formatAgeGroupName = function (group) {
        var indexMinorSymbol = group.indexOf('-');
        // if minor in the last, replace it by plus
        if (indexMinorSymbol === (group.length - 1)) {
            return group.substring(3).replace('-', '+');
        }
        else {
            return group.substring(3);
        }
    };
    DemographicHypeAuditorComponent.prototype.findAgeByGroup = function (group, data) {
        var matchedGroup = data.find(function (d) { return d.group === group; });
        return matchedGroup ? Math.round(matchedGroup.value) : 0;
    };
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "isAdmin", {
        get: function () {
            return this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "fallbackTitle", {
        get: function () {
            if (this.userService.isFreeUser() && !this.isAdmin) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "fallbackMessage", {
        get: function () {
            if (this.userService.isFreeUser() && !this.isAdmin) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "isExportingPdf", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    DemographicHypeAuditorComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(DemographicHypeAuditorComponent.COMPONENT_NAME);
    };
    Object.defineProperty(DemographicHypeAuditorComponent.prototype, "hasLanguagesChartData", {
        get: function () {
            return this.demographicData.languages && this.demographicData.languages.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    DemographicHypeAuditorComponent.COMPONENT_NAME = 'DemographicHypeAuditorComponent';
    return DemographicHypeAuditorComponent;
}());
export { DemographicHypeAuditorComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic-hype-auditor/demographic-hype-auditor.component.ts.pre-build-optimizer.js